// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Spinner-styles_spinner__38J1Y","sweep":"Spinner-styles_sweep__1GwD6","rota":"Spinner-styles_rota__1KMeX"};